import React, { createContext, useState, useCallback, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

const NotificationContext = createContext(null);

export let showGlobalNotification = () => {
  console.warn('showGlobalNotification called before NotificationProvider initialized');
};

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    show: false,
    message: '',
    type: 'success', // 'success' | 'error' | 'info'
  });

  const hideNotification = useCallback(() => {
    setNotification((prev) => ({ ...prev, show: false }));
  }, []);

  const showNotification = useCallback((message, type = 'success', duration = 5000) => {
    setNotification({
      show: true,
      message,
      type,
    });

    if (duration > 0) {
      setTimeout(() => {
        hideNotification();
      }, duration);
    }
  }, [hideNotification]);

  // Expose it globally for non-component files (like axios interceptor)
  useEffect(() => {
    showGlobalNotification = showNotification;

    const pendingMsg = window.localStorage.getItem('logoutNotification');
    if (pendingMsg) {
      setTimeout(() => {
        showNotification(pendingMsg, 'error');
      }, 100);
      window.localStorage.removeItem('logoutNotification');
    }
  }, [showNotification]);

  return (
    <NotificationContext.Provider value={{ notification, showNotification, hideNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};

NotificationProvider.propTypes = {
  children: PropTypes.node
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

export default NotificationContext;
